import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "message" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "message__title" }
const _hoisted_4 = { class: "message__content" }
const _hoisted_5 = { class: "message__actions" }
const _hoisted_6 = { class: "message__action-slot" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideWidget = _resolveComponent("SideWidget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.image)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: `${_ctx.config.publicPath}${_ctx.image}`,
          alt: _ctx.altText,
          class: "message__image"
        }, null, 8, _hoisted_2))
      : _renderSlot(_ctx.$slots, "image", { key: 1 }, undefined, true),
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "action", {}, undefined, true)
      ]),
      (_ctx.needHelp)
        ? (_openBlock(), _createBlock(_component_SideWidget, {
            key: 0,
            class: "message__contact"
          }, {
            label: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Need help?")
            ])),
            action: _withCtx(() => [
              _createElementVNode("a", {
                href: _ctx.contactUrl || _ctx.config.contactUsUrl
              }, "Contact Us", 8, _hoisted_7)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}